module.exports = __webpack_public_path__ + "static/img/6_v2.73a3da5e.png";